import {ParticleController} from "./ParticleController";
import {ParticleSettings} from "./ParticleSettings";
import {gsap} from "gsap";
import {Layers, WalkOfShameLayers} from "../../view/WalkOfShameLayers";
import {WalkOfShame} from "../../WalkOfShame";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class ParticlesManager extends PIXI.Container {
    private _confettiParticle: ParticleController;
    private _champagneLeft: PIXI.spine.Spine;
    private _champagneRight: PIXI.spine.Spine;
    private _showerLeft: PIXI.spine.Spine;
    private _showerRight: PIXI.spine.Spine;

    constructor() {
        super();

        WalkOfShameLayers.getLayer(Layers.PARTICLES)?.addChild(this);

        gsap.ticker.add(() => this.updateAll());
        this.initAnimations();
    }

    public playConfetti(): void {
        this._confettiParticle.enableEmit(true);

        this.onResize();
    }

    public playBottomChampagne(): void {
        [this._champagneLeft, this._champagneRight].forEach((item: PIXI.spine.Spine) => {
            item.visible = true;
            item.updateTransform();
        });
        this._champagneLeft.state.setAnimation(0, "ChampagneLeft", false);
        this._champagneRight.state.setAnimation(0, "ChampagneRight", false);
    }

    public boostBottomChampagne(): void {
        this._champagneLeft.state.clearTracks();
        this._champagneLeft.state.setAnimation(0, "ChampagneLeft_Plus", false);
        this._champagneRight.state.clearTracks();
        this._champagneRight.state.setAnimation(0, "ChampagneRight_Plus", false);
    }

    public playShower(): void {
        this.boostBottomChampagneLevel5();

        [this._showerLeft, this._showerRight].forEach((item: PIXI.spine.Spine) => {
            item.visible = true;
            item.updateTransform();
            item.state.setAnimation(0, "shower", false);
        });

        this.onResize();
    }

    public stopAll(): void {
        this._confettiParticle.enableEmit(false);

        [this._champagneLeft, this._champagneRight, this._showerLeft, this._showerRight].forEach((item: PIXI.spine.Spine) => {
            item.visible = false;
            item.state.clearTracks();
        });
    }

    public onResize(): void {
        if (!this._confettiParticle) {
            return;
        }

        const screenBounds: ScreenBounds = NolimitApplication.screenBounds;

        this._showerLeft.x = screenBounds.left;
        this._showerRight.x = screenBounds.right;

        if (NolimitApplication.isLandscape) {
            this._confettiParticle.setPos(new PIXI.Point(-480, 0));

            this._champagneLeft.position.set(0, 720);
            this._champagneRight.position.set(720);
        } else {
            this._confettiParticle.setPos(new PIXI.Point(0, -280));

            this._champagneLeft.position.set(120, 720);
            this._champagneRight.position.set(600, 720);
        }
    }

    private initAnimations(): void {
        this._confettiParticle = new ParticleController(this, "BigWinParticle", "Bigwin/confetti/confetti_", ParticleSettings.confetti);

        this._champagneLeft = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("champagne"));
        this._champagneLeft.visible = false;

        this._champagneRight = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("champagne"));
        this._champagneRight.visible = false;

        this._showerLeft = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("champagne"));
        this._showerLeft.visible = false;
        this._showerLeft.scale.x = -1;
        this._showerLeft.y = 60;

        this._showerRight = new PIXI.spine.Spine(WalkOfShame.assetLoader.getSpineAsset("champagne"));
        this._showerRight.visible = false;
        this._showerRight.y = 60;

        this.addChild(this._champagneLeft, this._champagneRight, this._showerLeft, this._showerRight);
    }

    private updateAll(): void {
        this._confettiParticle.update();
    }

    private boostBottomChampagneLevel5(): void {
        this._champagneLeft.state.clearTracks();
        this._champagneLeft.state.setAnimation(0, "level05Left_Plus", false);
        this._champagneRight.state.clearTracks();
        this._champagneRight.state.setAnimation(0, "level05Right_Plus", false);
    }
}